import Price from '../shop/Price';
import { TAX_RATE } from '../../../utils/tax';

type Props = {
  order: IOrder,
  ignoreShipping?: boolean
}


const InvoiceReviewTotal = ({ order, ignoreShipping }: Props) => {
  // Prefer the server-recorded total (subtotal − discount + tax); recompute
  // only for order shapes that carry no server total.
  if (order.total !== undefined) {
    return <Price price={order.total} showZero />;
  }
  const items = order.items;
  const subtotal = items.filter(item => !item.item.name.startsWith("Shipping")).reduce((subtotal, item) => subtotal + (item.count * (item.item.price ? item.item.price : 0)), 0);
  const shipping = items.filter(item => item.item.name.startsWith("Shipping")).reduce((subtotal, item) => subtotal + (item.count * (item.item.price ? item.item.price : 0)), 0);
  const discountedSubtotal = order.discountAmount ? subtotal - order.discountAmount : subtotal;

  const taxes = Math.round((discountedSubtotal + shipping) * TAX_RATE);

  const total = discountedSubtotal + shipping + taxes;

  return (
    <Price price={total}/>
  )
}

export default InvoiceReviewTotal